/* Wrapper class for the headless `AppShell`.
 *
 * AppShell always renders one <div> around whichever branch is active. On the
 * extension that div IS the panel chrome (`sidepanel-container`), but here it
 * would land between `#root` — a `height: 100dvh` flex column — and
 * `MainPage`'s `.shell`, which sizes itself with `height: 100%`. A default
 * div is a content-sized flex item, so `100%` would resolve against a
 * collapsed parent and the whole app would lose its full-height layout.
 *
 * `display: contents` removes the box entirely rather than trying to
 * replicate the right flex/height rules on it, so the branch content stays a
 * direct flex child of `#root` and the layout is byte-for-byte what it was
 * before AppShell was adopted. The element carries no semantics of its own,
 * so dropping its box costs nothing — the same reason `App.tsx` already uses
 * `display: contents` for its `inert` wrapper. */
.shellRoot {
  display: contents;
}
